import { borderRadius } from 'library/helpers/style_utils';
import styled from 'styled-components';

export const LeafletMapWrapper = styled.div`
	height: 100%;
	width: 100%;
	position: relative;
	background-color: #fff;

	/* 🎯 Custom draw marker button */

	.leaflet-draw-toolbar {
		.leaflet-draw-draw-marker {
			/* Location pin icon - black color, reduced size */
			background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='14' height='18' viewBox='0 0 14 18' fill='none'><path d='M13 7.5C13 11.2448 8.84575 15.1447 7.45075 16.3492C7.32079 16.447 7.1626 16.4998 7 16.4998C6.8374 16.4998 6.67921 16.447 6.54925 16.3492C5.15425 15.1447 1 11.2448 1 7.5C1 5.9087 1.63214 4.38258 2.75736 3.25736C3.88258 2.13214 5.4087 1.5 7 1.5C8.5913 1.5 10.1174 2.13214 11.2426 3.25736C12.3679 4.38258 13 5.9087 13 7.5Z' stroke='%23545454' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/><path d='M7 9.75C8.24264 9.75 9.25 8.74264 9.25 7.5C9.25 6.25736 8.24264 5.25 7 5.25C5.75736 5.25 4.75 6.25736 4.75 7.5C4.75 8.74264 5.75736 9.75 7 9.75Z' stroke='%23545454' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/></svg>") !important;
			background-repeat: no-repeat !important;
			background-position: center !important;
			text-indent: -9999px; /* Hide fallback text */
			width: 36px !important;
			height: 36px !important;
			transition: all 0.2s ease;
			background-color: #ffffff; /* White background */
			border: none !important;
			border-radius: 6px !important;
			box-shadow: 0 6.75px 21px 6px rgba(0, 0, 0, 0.05), 0 2.25px 4.5px -3px rgba(0, 0, 0, 0.12),
				0 4.5px 12px 0 rgba(0, 0, 0, 0.08) !important;
		}
	}

	/* 📏 Prevent toolbar container from stretching */
	.leaflet-draw-toolbar {
		display: flex;
		flex-direction: column;
		align-items: center;
		width: auto !important;
		box-shadow: none;
	}

	/* ✋ Style for the "Cancel" action menu */
	.leaflet-draw-actions {
		position: absolute;
		top: 0% !important;
		right: 10%;
		transform: translate(-60%, -10px); /* Push upwards and center horizontally */
		width: max-content;
		background: #fff;
		border: none;
		border-radius: 6px;
		padding: 0;
		list-style: none;
		z-index: 9;

		li a {
			display: block;
			padding: 6px 12px;
			font-size: 13px;
			color: #333;
			text-decoration: none;
			transition: background 0.2s ease;

			&:hover {
				background: #000;
				color: #fff;
			}
		}
	}
	.leaflet-draw-toolbar.leaflet-bar.leaflet-draw-toolbar-top {
		border: 0 !important;
		box-shadow: none !important;
	}
`;

export const MapModalWrapper = styled.div`
	height: 80vh;
	width: 100%;
	${borderRadius('10px')};
	overflow: hidden;
`;
export default LeafletMapWrapper;
